import { getCommentP } from 'create-api';
import * as types from '../mutation-types';

// initial state
const state = {
    commentInfo: {},
    commentLoading: false,
    isLoaded: true,
    scrollLoading: false,
    loadCommentFlag: true
};

const getters = {
    isLoaded: state => state.isLoaded
}

// actions
const actions = {
    getComment({ commit, state }, { productId, page, selectedType }) {
        if (state.commentInfo.currentPage === 1) {
            commit(types.LOADING_COMMENT_START);
        } else {
            commit(types.LOADING_SCROLL_START);
        }
        getCommentP({
            productId,
            page,
            selectedType
        }).then(data => {
            if (data && data.list) {
                commit(types.RECEIVE_COMMENT, { commentInfo: data });
            } else {
                commit(types.RECEIVE_COMMENT, { commentInfo: {} });
            }
            commit(types.LOADING_COMMENT_END);
            commit(types.LOADING_SCROLL_END);
        }).catch(err => {
            commit(types.LOADING_COMMENT_END);
            commit(types.LOADING_SCROLL_END);
            console.error(err);
        }).finally(()=>{
            commit(types.LOAD_COMMENT_FLAG, { loadCommentFlag: true });
        });       
    },
    changeCommentPage({ commit }, { page }) {
        commit(types.CHANGE_COMMENT_PAGE, { page });
    },
    changeCommentType({ commit }, { type }) {
        commit(types.CHANGE_COMMENT_TYPE, { type });
    },
    changeLoadCommentFlag({ commit },{ loadCommentFlag }) {
        commit(types.LOAD_COMMENT_FLAG, { loadCommentFlag })
    }
};

// mutations
const mutations = {
    [types.RECEIVE_COMMENT] (state, payload) {
        if (payload.commentInfo) {
            if (state.commentInfo.list && state.commentInfo.list.length > 0 && state.commentInfo.currentPage > 1) {
                payload.commentInfo.list.unshift(...state.commentInfo.list);
            }
            state.commentInfo = payload.commentInfo;
        }
    },
    [types.CHANGE_COMMENT_PAGE] (state, payload) {
        if (state.commentInfo) {
            state.commentInfo.currentPage = payload.page;
        }
    },
    [types.CHANGE_COMMENT_TYPE] (state, payload) {
        if (state.commentInfo && Array.isArray(state.commentInfo.selectedTypeList)) {
            state.commentInfo.selectedTypeList.forEach(el => {
                el.isSelected = el.selectedType === payload.type;
            });
        }
    },
    [types.LOADING_COMMENT_START] (state, payload) {
        state.commentLoading = true;
    },
    [types.LOADING_COMMENT_END] (state, payload) {
        state.commentLoading = false;
    },
    [types.LOADING_SCROLL_START] (state, payload) {
        state.scrollLoading = true;
    },
    [types.LOADING_SCROLL_END] (state, payload) {
        state.scrollLoading = false;
    },
    [types.LOAD_COMMENT_FLAG] (state, payload) {
        state.loadCommentFlag = payload.loadCommentFlag
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};


// WEBPACK FOOTER //
// libs/store/modules/comment.js